import { useEffect, useState } from "react";
import { loginForAccessToken, readUsersMe } from "@/api";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { appState } from "@/app/appState";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { PublicPageShell } from "@/components/PublicPageShell";

export default observer(function SignIn() {

    // the auth provider handles navigation on succesfull login:)
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e: { preventDefault: () => void }) => {
        e.preventDefault(); // stops page from reloading

        try {
            appState.login(username, password);
        } catch (err) {
            console.error("Login error:", err);
        }
    };

    return (
        <PublicPageShell contentClassName="items-center justify-center p-3">
            <div className="auth-card">
                <p className="auth-title">{appState.t("auth.signIn")}</p>
                <div>
                    {/* <small className="">Fill in your username and password to sign in</small> */}

                    <form onSubmit={handleSubmit} className="flex flex-col gap-1 items-start">
                        <label htmlFor="username" className="l mt-1">
                            {appState.t("common.email")}
                        </label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="input"
                            required
                        />

                        <label htmlFor="password" className="l mt-1">
                            {appState.t("common.password")}
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input"
                            required
                        />

                        <button
                            type="submit"
                            disabled={appState.loadingAuth}
                            className="btn btn-primary btn-block mt-1"
                        >
                            {appState.loadingAuth ? appState.t("auth.signingIn") : appState.t("auth.signIn")}
                        </button>
                    </form>

                    <div className="mt-4 flex flex-col gap-2">
                        <div className="divider-label">{appState.t("common.or")}</div>

                        <button
                            onClick={() => window.location.href = '/api/auth/login/google'}
                            className="btn btn-block"
                        >
                            {appState.t("auth.signInGoogle")}
                        </button>
                    </div>
                </div>
            </div>
        </PublicPageShell>
    );
});